import { DeploymentTargetRecord } from '../types/deployment';

const isAllowedMode = (target: DeploymentTargetRecord | null | undefined, mode: string): boolean => {
  if (!mode) {
    return false;
  }

  const allowedModes = target?.allowedDeploymentModes ?? [];
  return allowedModes.length === 0 || allowedModes.includes(mode);
};

export const resolvePreferredSetupMode = (
  target: DeploymentTargetRecord | null | undefined
): string => {
  const candidates = [
    target?.setupState?.lastSetupMode,
    target?.defaultDeploymentMode,
    target?.allowedDeploymentModes?.[0],
  ];

  for (const candidate of candidates) {
    const normalized = String(candidate || '').trim();
    if (isAllowedMode(target, normalized)) {
      return normalized;
    }
  }

  return '';
};

export const formatDeploymentModeLabel = (mode: string): string => {
  switch (mode) {
    case 'docker':
      return 'Docker / Compose';
    case 'static':
      return 'Static frontend';
    case 'package':
      return 'Package / Node.js service';
    case 'appimage':
      return 'AppImage / Electron';
    default:
      return mode || 'Default';
  }
};

export const resolveRollbackMode = (
  deploymentMode: string | undefined,
  target: DeploymentTargetRecord | null | undefined
): string => {
  const recordedMode = String(deploymentMode || '').trim();
  if (isAllowedMode(target, recordedMode)) {
    return recordedMode;
  }

  return '';
};
